<template>
  <div class="card" v-show="currentCardId == 'license-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>免許・資格を入力</h2>
        <p>保有している免許や資格を入力してください</p>
      </div>
      <div class="card-content card-content-list">
        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <HistoryItem
              v-for="(item, index) in formatData.licenseHistories"
              :key="item.uuid"
              @add-history-item="addLicenseHistory"
              @delete-history-item="deleteLicenseHistory"
              @move-history-item="moveLicenseHistory"
              @click.native="activateHistoryItem(item.uuid)"
              :item="item"
              :length="formatData.licenseHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'免許・資格名を入力'"
              :descriptionMaxLength="MAX_LICENSE_LENGTH"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              :disabled="
                formatData.licenseHistories.length >= MAX_LICENSE_HISTORIES
              "
              @click="addLicenseHistory()"
            />
            <p
              v-if="formatData.licenseHistories.length >= MAX_LICENSE_HISTORIES"
              class="limit-message"
            >
              免許・資格は{{ MAX_LICENSE_HISTORIES }}件まで登録できます
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import {
  MAX_LICENSE_HISTORIES,
  MAX_LICENSE_LENGTH,
  useEnglishResumeFormatData,
  useEnglishResumeHistoriesApi
} from '@/composables/format-edit/useEnglishResumeFormatData'

defineProps<{
  currentCardId?: string
  basicData: Record<string, unknown>
}>()

const formatData = useEnglishResumeFormatData()
const {
  activeHistoryItem,
  addLicenseHistory,
  deleteLicenseHistory,
  moveLicenseHistory,
  activateHistoryItem
} = useEnglishResumeHistoriesApi()
</script>

<style scoped lang="scss">
.limit-message {
  margin: 8px 0 0;
  font-size: 0.78rem;
  color: #999;
  text-align: center;
}
</style>
